<template>
  <b-container active @click="tabClick(2017)" :id="`electric-${year}`">
    <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">
      <b-row>
        <b-col cols="9">
          Electricity Data <p/>
          <span
              style="font-size: medium; font-weight: normal ">*Note: PG&E does not track your solar energy use, this must be requested from your solar vendor</span>
        </b-col>
        <b-col cols="3" class="text-right">
          <b-button size="sm" @click="requestDownload()">
            Export Electricity Data
          </b-button>
        </b-col>
      </b-row>
    </div>
    <ag-grid-vue style="width: 100%; height: 400px"
                 class="ag-theme-balham"
                 :gridOptions="topGridOptions"
                 :columnDefs="columnDefs"
                 :rowData="rowData"
                 :defaultColDef="defaultColDef"
                 :enterMovesDownAfterEdit="true"
                 @grid-ready="onGridReady"
                 @cell-clicked="onCellClicked"
                 @cell-editing-stopped="onCellEditingStopped">
    </ag-grid-vue>
    <ag-grid-vue style="width: 100%; height: 40px;"
                 class="ag-theme-balham"
                 :gridOptions="bottomGridOptions"
                 :headerHeight="0"
                 :columnDefs="bottomColumnDefs"
                 :rowData="bottomDataCalc"
                 :rowStyle="rowStyle"
    ></ag-grid-vue>

  </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import Bus from "../../../eventBus";
import {roundColumnValue} from "@/MetricUtils";
import {FileUtils} from "@/lib/FileUtils";

const SizeEnum = {
  SO: 'solar',
  AG1: 'ag1',
  AG2: 'ag2',
  AG3: 'ag3'
};

window.numberParser = function numberParser(params) {
  let parsedNumber = Number(params.newValue);
  return isNaN(parsedNumber) ? "ERROR" : parsedNumber;
};

export default {
  name: "VineyardPowerMetricTable",
  props: {rows: Array, year: String, id: String, groupId: String},
  components: {
    AgGridVue
  },

  data() {
    return {
      metricYearVal: this.year,
      gridApi: null,
      gridColumnApi: null,
      bottomColumnDefs: null,
      columnDefs: null,
      defaultColDef: null,
      pinnedTopRowData: null,
      pinnedBottomRowData: null,
      topGridOptions: null,
      bottomGridOptions: null,
      rowData: this.rows,
      bottomData: [],
      rowStyle: {fontWeight: 'bold'},
      enteredValueDecimalPlaces: 0,
      totalsValueDecimalPlaces: 0,
      metricId: this.id,
      myGroupId: this.groupId,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER')
    }
  },
  created() {
    //Bus.$on('update-requests', this.sendInitialMetricsUpdate);

  },
  beforeDestroy() {
    //Bus.$off('update-requests', this.sendInitialMetricsUpdate);
  },
  mounted() {
    this.gridApi = this.topGridOptions.api;
    this.gridColumnApi = this.topGridOptions.columnApi;
    //this.$nextTick(this.sendInitialMetricsUpdate(this.metricYearVal))
  },
  watch: {
    rows: function (newVal, oldVal) {
      console.log(`Rows old val: ${oldVal}`)
      this.rowData = newVal;
    },
    year: function (newVal, oldVal) {
      console.log(`Year old val: ${oldVal}`)
      this.metricYearVal = newVal;
    },
    id: function (newVal, oldVal) {
      console.log(`Id old val: ${oldVal}`)
      this.metricId = newVal;
    },
    groupId: function (newVal, oldVal) {
      console.log(`GroupId old val: ${oldVal}`)
      this.myGroupId = newVal;
    }
  },
  beforeMount() {

    this.columnDefs = [
      {
        headerName: 'Month', field: 'month', pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Year', field: 'year', pinned: "left",
        lockPinned: true,
        width: 75,
        editable: false
      },
      {
        headerName: 'Solar Production (kWh)',
        field: 'solar',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.enteredValueDecimalPlaces)
      },
      {
        headerName: 'Ag Meter 1 (kWh)',
        field: 'ag1',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.enteredValueDecimalPlaces)
      },
      {
        headerName: 'Ag Meter 2 (kWh)',
        field: 'ag2',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.enteredValueDecimalPlaces)
      },
      {
        headerName: 'Ag Meter 3 (kWh)',
        field: 'ag3',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.enteredValueDecimalPlaces)
      },
    ];
    this.bottomColumnDefs = [
      {
        headerName: 'Month', field: 'month', pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Year', field: 'year', pinned: "left",
        lockPinned: true,
        width: 75,
        editable: false
      },
      {
        headerName: 'Solar Production (kWh)',
        field: 'solar',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.totalsValueDecimalPlaces)
      },
      {
        headerName: 'Ag Meter 1 (kWh)',
        field: 'ag1',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.totalsValueDecimalPlaces)
      },
      {
        headerName: 'Ag Meter 2 (kWh)',
        field: 'ag2',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.totalsValueDecimalPlaces)
      },
      {
        headerName: 'Ag Meter 3 (kWh)',
        field: 'ag3',
        valueParser: numberParser,
        editable: !this.isViewer,
        valueFormatter: params => roundColumnValue(params.data[params.column.colId], this.totalsValueDecimalPlaces)
      },
    ];
    this.bottomData = [
      {
        month: 'Total',
        year: '******',
        solar: 'a lot',
        ag1: 'not as much',
        ag2: 'a little more',
        ag3: '=ctx.sum("solarProductivity")'
      }
    ];


    this.defaultColDef = {
      editable: true,
      resizable: true
    };

    this.pinnedTopRowData = getPinnedTopData();
    this.pinnedBottomRowData = getPinnedBottomData();

    this.topGridOptions = {alignedGrids: [], suppressHorizontalScroll: true};
    this.bottomGridOptions = {
      alignedGrids: [], enableCellExpressions: true, context: {
        theNumber: 4
      }
    };
    this.topGridOptions.alignedGrids.push(this.bottomGridOptions);
    this.bottomGridOptions.alignedGrids.push(this.topGridOptions);

    let totalSolar = 0;
    let totalAgg1 = 0;
    let totalAgg2 = 0;
    let totalAgg3 = 0;
    if (self.gridApi !== undefined) {
      self.gridApi.forEachNode(function (node) {
        if (node.data["year"] === event.data["year"]) {
          //total += parseInt(node.data[event.colDef.field], 10);
          totalSolar += Number(node.data["solar"]) || 0;
          totalAgg1 += Number(node.data["ag1"]) || 0;
          totalAgg2 += Number(node.data["ag"]) || 0;
          totalAgg3 += Number(node.data["ag3"]) || 0;
        }
      });
    }
    //this.calculateAndEmitTotals(totalSolar, totalAgg1, totalAgg2, totalAgg3, "beforeMount", event);

  },
  computed: {
    bottomDataCalc: function () {

      let self = this;
      let bottomRowsMap = new Map();
      let columnNames = [];
      Object.values(SizeEnum).map(key => {
        let result = 0;
        Object.values(self.rowData).forEach(row => {

          result += row[key];

        });
        columnNames.push(result);
      });

      let bottom =
          {
            month: "Total",
            year: '******',
            solar: 0,
            ag1: 0,
            ag2: 0,
            ag3: 0
          };
      if (bottomRowsMap !== undefined) {
        bottom = {
          month: "Total",
          year: '******',
          solar: Number(columnNames[0]),
          ag1: Number(columnNames[1]),
          ag2: Number(columnNames[2]),
          ag3: Number(columnNames[3])
        };
      }

      console.log(bottom);

      return [bottom];
    }

  },
  methods: {
    bottomDataCalcFunc: function (year) {
      console.log(`Year old val: ${year}`);
      let bottom =
          {
            month: "Total",
            year: '******',
            solarProductivity: 0,
            electricMeter: 0,
            electricMeter2: 0,
            electricMeter3: 0
          };
      return [bottom];
    },
    tabClick: function () {
    },
    onBtStopEditing() {
      this.gridApi.stopEditing();

    },
    cellValueChanged() {
      this.bottomGridOptions.api.refreshView();
    },
    onBtStartEditing(key, char, pinned) {
      this.gridApi.setFocusedCell(0, "month", pinned);
      this.gridApi.startEditingCell({
        rowIndex: 0,
        colKey: "month",
        rowPinned: pinned,
        keyPress: key,
        charPress: char
      });
    },
    onBtNextCell() {
      this.gridApi.tabToNextCell();
    },
    onBtPreviousCell() {
      this.gridApi.tabToPreviousCell();
    },
    onBtWhich() {
      let cellDefs = this.gridApi.getEditingCells();
      if (cellDefs.length > 0) {
        var cellDef = cellDefs[0];
        console.log(
            "editing cell is: row = " +
            cellDef.rowIndex +
            ", col = " +
            cellDef.column.getId() +
            ", floating = " +
            cellDef.floating
        );
      } else {
        console.log("no cells are editing");
      }
    },
    onGridReady(params) {
      console.log(`Grid is ready: ${params}`)
      this.gridApi = this.topGridOptions.api;
      this.gridColumnApi = this.topGridOptions.columnApi;
      const updateData = data => {
        this.rowData = data;
      };
    },
    onCellClicked(event) {
      //console.log('onCellClicked: ' + event.rowIndex + ' ' + event.colDef.field);

    },
    calculateAndEmitTotals: function (totalSolar, totalElec, totalElec2, totalElec3, when, event) {
      console.log("Total: " + totalSolar);
      this.bottomGridOptions.api.getRowNode('0').data[SizeEnum.SO] = totalSolar;
      this.bottomGridOptions.api.getRowNode('0').data[SizeEnum.AG1] = totalElec;
      this.bottomGridOptions.api.getRowNode('0').data[SizeEnum.AG2] = totalElec2;
      this.bottomGridOptions.api.getRowNode('0').data[SizeEnum.AG3] = totalElec3;

      let powerEmission = {
        gridType: "powerEmission",
        solar: totalSolar,
        agMeter1: totalElec,
        agMeter2: totalElec2,
        agMeter3: totalElec3,
        year: Number(this.metricYearVal),
        when: when
      };
      // this.$store.commit('solar', totalSolar);
      // this.$store.commit('agMeter1', totalElec);
      // this.$store.commit('agMeter2', totalElec2);
      // this.$store.commit('agMeter3', totalElec3);
      Bus.$emit('vineyard-power-edited', powerEmission);
    },
    calculateAndUpdateTotalsVuex: function (totalSolar, totalElec, totalElec2, totalElec3, when, event) {
      console.log("Total: " + totalSolar);
      this.bottomGridOptions.api.getRowNode('0').data[SizeEnum.SO] = totalSolar;
      this.bottomGridOptions.api.getRowNode('0').data[SizeEnum.AG1] = totalElec;
      this.bottomGridOptions.api.getRowNode('0').data[SizeEnum.AG2] = totalElec2;
      this.bottomGridOptions.api.getRowNode('0').data[SizeEnum.AG3] = totalElec3;

      let powerEmission = {
        gridType: "powerEmission",
        solar: totalSolar,
        agMeter1: totalElec,
        agMeter2: totalElec2,
        agMeter3: totalElec3,
        year: Number(this.metricYearVal),
        when: when
      };
      this.$store.commit('solar', totalSolar);
      this.$store.commit('agMeter1', totalElec);
      this.$store.commit('agMeter2', totalElec2);
      this.$store.commit('agMeter3', totalElec3);
    },
    // sendInitialMetricsUpdate(year) {
    //   let self = this;
    //   let totalSolar = 0;
    //   let totalElec = 0;
    //   let totalElec2 = 0;
    //   let totalElec3 = 0;
    //
    //   if (this.gridApi !== undefined) {
    //     console.log("Traverse GridApi");
    //     this.gridApi.forEachNode(function (node) {
    //       if (node.data["year"] === year) {
    //         totalSolar += self.safeParseNumber(node, SizeEnum.SO);
    //         totalElec += self.safeParseNumber(node, SizeEnum.AG1);
    //         totalElec2 += self.safeParseNumber(node, SizeEnum.AG2);
    //         totalElec3 += self.safeParseNumber(node, SizeEnum.AG3);
    //       }
    //     });
    //   }
    //   this.calculateAndEmitTotals(totalSolar, totalElec, totalElec2, totalElec3, "gridReady", event);
    // },
    safeParseNumber: function (node, indexName, updateCell = false) {
      console.debug(`Should update cell; ${updateCell}`);
      let isNotANumber = isNaN(node.data[indexName]);
      return isNotANumber ? 0 : node.data[indexName];
    },
    requestDownload() {
      let self = this;
      this.$http.get(`metrics/download/${self.myGroupId}/${self.metricYearVal}/power/vineyard`, {responseType: "blob"})
          .then(async response => {
            FileUtils.saveExcelToDisk(response);
          });
    },
    updatePowerMetrics: function () {
      let self = this;
      if (self.gridApi !== undefined) {
        let year = {};
        let powerMetricsMonth = [];
        self.gridApi.forEachNode(function (node) {
          year = node.data["year"];
          powerMetricsMonth.push({
            month: node.data["month"],
            solar: self.safeParseNumber(node, SizeEnum.SO),
            ag1: self.safeParseNumber(node, SizeEnum.AG1),
            ag2: self.safeParseNumber(node, SizeEnum.AG2),
            ag3: self.safeParseNumber(node, SizeEnum.AG3),
          })
        });
        let metricYear = {
          _id: this.metricId,
          year: year,
          groupId: this.myGroupId,
          months: powerMetricsMonth
        };
        console.log("Metrics Year");
        console.log(JSON.stringify(metricYear));
        this.$http.put(`/metrics/vineyard/power/${this.metricId}`, JSON.stringify(metricYear), {
          headers: {
            'content-type': 'application/json'
          }
        }).then(response => {
          console.log(response);
          // TODO Add Notification for Updated Metrics
          if (self.metricId === null) {
            self.metricId = response.data;
          }
        }).catch(error => {
          console.log("Error Putting Data");
          console.error(error);
        })
      }
    },
    onCellEditingStopped(event) {
      let self = this;
      let totalSolar = 0;
      let totalElec = 0;
      let totalElec2 = 0;
      let totalElec3 = 0;
      if (self.gridApi !== undefined) {
        self.gridApi.forEachNode(function (node) {
          if (node.data["year"] === event.data["year"]) {
            totalSolar += self.safeParseNumber(node, SizeEnum.SO);
            totalElec += self.safeParseNumber(node, SizeEnum.AG1);
            totalElec2 += self.safeParseNumber(node, SizeEnum.AG2);
            totalElec3 += self.safeParseNumber(node, SizeEnum.AG3);
          }
        });
      }
      //TODO This is where I re-enable Database update
      this.updatePowerMetrics();

      this.calculateAndUpdateTotalsVuex(totalSolar, totalElec, totalElec2, totalElec3, "cellStoppedEditing", event);
      this.bottomGridOptions.api.redrawRows({rowNodes: [this.bottomGridOptions.api.getRowNode('0')]})
    }
  }
}

function getPinnedTopData() {
  return [
    {
      firstName: "##",
      lastName: "##",
      gender: "##",
      address: "##",
      mood: "##",
      country: "##"
    }
  ];
}

function getPinnedBottomData() {
  return [
    {
      firstName: "##",
      lastName: "##",
      gender: "##",
      address: "##",
      mood: "##",
      country: "##"
    }
  ];
}

function getCharCodeFromEvent(event) {
  event = event || window.event;
  return typeof event.which === "undefined" ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
  return !!/\d/.test(charStr);
}

function isKeyPressedNumeric(event) {
  let charCode = getCharCodeFromEvent(event);
  let charStr = String.fromCharCode(charCode);
  return isCharNumeric(charStr);
}
</script>

<style scoped>

</style>
